import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import app from "./modules/app";
import user from "./modules/user";
import study from "./modules/study";
import editor from "./modules/editor";
import search from "./modules/search";

const state = {
	
};

const store = new Vuex.Store({
	state,
	modules: {
		app,
		study,
		user,
		editor,
		search
	},
	strict: process.env.NODE_ENV !== "production"
});

export default store;